import { createContext } from "react";

export const TemporadasContext = createContext()
export const TemporadasFormContext = createContext()
export const TemporadasReportContext = createContext()